// extracted by mini-css-extract-plugin
export var chatButton = "footer-module--chatButton--92a08";
export var emailLink = "footer-module--emailLink--ae058";
export var footerBottom = "footer-module--footerBottom--e9b1b";
export var footerTop = "footer-module--footerTop--851ea";
export var iconRow = "footer-module--iconRow--ecc82";
export var mainFooter = "footer-module--mainFooter--7fc15";
export var menuContainer = "footer-module--menuContainer--af3e9";
export var menuHeader = "footer-module--menuHeader--49346";
export var phoneLink = "footer-module--phoneLink--0ef87";
export var secondCol = "footer-module--secondCol--19a98";